import React from 'react';
import { connect } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';

import {
  getClientAllowanceItemList,
  setClientAllowanceItemList,
  saveChangedDisplayOrder
} from 'src/reducers/clients/allowanceItems';
import { CLIENT_ALLOWANCE_ITEMS, CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import ActionButton from 'jbc-front/components/ActionButton';
import { MinusCircle, Strage } from 'jbc-front/components/icons';
import SortableAllowanceItemTable from './SortableAllowanceItemTable';
import styles from './SortableAllowanceItemsComponent.scss';
import { withTranslation } from 'react-i18next';

class SortableAllowanceItemsComponent extends React.Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { allowanceItems } = this.props;
    this.props.setAllowanceItemList(arrayMove([...allowanceItems], oldIndex, newIndex));
  };

  render() {
    const { allowanceItems, saveDisplayOrder, t } = this.props;

    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{t('features.ClientAllowanceItems.components.SortableAllowanceItemsComponent.Attendance_Items_Sorting')}</h1>
        </div>
        <div className="l-wrap-xl l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={t('features.ClientAllowanceItems.components.SortableAllowanceItemsComponent.Attendance_Items_Sorting')} />
            </BreadCrumb>
          </div>
          <div className={styles.action}>
            <ActionButton onClick={saveDisplayOrder} icon={<Strage size={15} />}>
              {t('features.EmployeeBonus.components.ActionButtonSection.save')}
            </ActionButton>
            <ActionButton as="a" href={CLIENT_ALLOWANCE_ITEMS} icon={<MinusCircle size={15} />}>
              {t('features.EmployeeBonus.components.ActionButtonSection.cancel')}
            </ActionButton>
          </div>
          <SortableAllowanceItemTable
            allowanceItems={allowanceItems}
            onSortEnd={this.onSortEnd}
            helperClass={styles.dragging}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(
  state => ({
    allowanceItems: getClientAllowanceItemList(state)
  }),
  dispatch => ({
    setAllowanceItemList: allowanceItems => {
      dispatch(setClientAllowanceItemList(allowanceItems));
    },
    saveDisplayOrder: () => {
      dispatch(saveChangedDisplayOrder());
    }
  })
)(SortableAllowanceItemsComponent));
